import { errorHandlingActions } from "../redux/error-handling-slice";
import { fetchEndpointRetry } from "./fetchEndpointRetry";
import { uiDataActions } from "../redux/uiData-slice";
import { processResponse } from "./processResponse";
import { addEntities } from "../redux/entities-action";
import ErrorBoundaryTypes from "../../errors/errorBoundaryTypes";
import endpointsAuth from "../models/endPointsAuth";
import endpointsStatuses from "../models/endpointsStatuses";

const updateGeneralConnectorsProcessStatus = (providers, status, dispatch, systemIdArr) => {

    providers.map((provider) => {
        if (provider.endpoints) {
            Object.keys(provider.endpoints)?.map(async endpointKey => {
                if (provider.endpoints[endpointKey].generalConnector && (!systemIdArr || (systemIdArr && !provider.systemId.includes(Object.keys(systemIdArr))))) {
                    dispatch(uiDataActions.updateConnectorsProcessStatus({
                        providerName: provider.name,
                        endpoint: endpointKey,
                        status: status
                    }));
                }
            })
        }
    })
}

const addCoursesToRedux = (res, dispatch) => {
    res.entitiesList && dispatch(addEntities(res.providerName, res.entitiesList, res.endpointKey));
    // res.eventsList && dispatch(addEvents(res.providerName, res.eventsList, res.endpointKey));
    // res.coursesList && dispatch(addCourses(res.providerName, res.coursesList, res.endpointKey));
    // res.assessmentsList && dispatch(assessmentActions.add(res.assessmentsList));
}

export const fetchConnectorsData = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const metadata = state.uiData;
        const isAuth = state.auth.isAuth;
        const lang = state.translate.lang;
        if (metadata) {
            if (metadata.generalConnector) {
                const generalConnector = metadata.generalConnector;
                Object.keys(generalConnector.endpoints).map(async (endpointKey) => {
                    try {
                        const endpoint = endPointWithKey(generalConnector.endpoints[endpointKey], endpointKey);
                        if (shouldFetchEndpoint(endpoint, isAuth)) {
                            const res = await fetchEndpointRetry(endpoint);
                            if (!res || res?.length === 0) {
                                updateGeneralConnectorsProcessStatus(metadata.providers, endpointsStatuses.completed, dispatch)
                            }
                            const resBySystemId = groupCoursesBySystemId(res);

                            for (const [systemId, systemRes] of Object.entries(resBySystemId)) {
                                let provider;
                                try {
                                    provider = findProviderBySystemId(metadata.providers, systemId);
                                    if (provider) {
                                        const providerEndpoint = provider.endpoints[endpointKey];
                                        const mergedEndpoint = { ...endpoint, ...providerEndpoint };

                                        const resProcessResponse = processResponse(endpoint.responseType, systemRes, mergedEndpoint, provider, metadata)
                                        if (resProcessResponse)
                                            addCoursesToRedux(resProcessResponse, dispatch)

                                        dispatch(uiDataActions.updateConnectorsProcessStatus({
                                            providerName: provider.name,
                                            endpoint: endpointKey,
                                            status: endpointsStatuses.completed
                                        }));
                                    }
                                }
                                catch (e) {
                                    console.error(e);
                                    dispatch(uiDataActions.updateConnectorsProcessStatus({
                                        providerName: provider?.name,
                                        endpoint: endpoint.endpointKey,
                                        status: endpointsStatuses.failed
                                    }));
                                }
                            }
                            updateGeneralConnectorsProcessStatus(metadata.providers, endpointsStatuses.completed, dispatch, resBySystemId)
                        }
                    }
                    catch (e) {
                        console.error(e);
                        updateGeneralConnectorsProcessStatus(metadata.providers, endpointsStatuses.failed, dispatch)
                    }
                });
            }

            if (metadata.providers) {
                metadata.providers.map(async (provider) => {
                    if (provider.endpoints) {
                        Object.keys(provider.endpoints)?.map(async endpointKey => {
                            const endpoint = endPointWithKey(provider.endpoints[endpointKey], endpointKey);

                            if (shouldFetchEndpoint(endpoint, isAuth)) {
                                try {
                                    const res = await fetchEndpointRetry(endpoint, lang);

                                    const resProcessResponse = processResponse(endpoint.responseType, res, endpoint, provider, metadata)
                                    if (resProcessResponse)
                                        addCoursesToRedux(resProcessResponse, dispatch)

                                    dispatch(uiDataActions.updateConnectorsProcessStatus({
                                        providerName: provider.name,
                                        endpoint: endpointKey,
                                        status: endpointsStatuses.completed
                                    }))
                                }
                                catch (e) {
                                    console.error(e)
                                    dispatch(uiDataActions.updateConnectorsProcessStatus({
                                        providerName: provider.name,
                                        endpoint: endpointKey,
                                        status: endpointsStatuses.failed
                                    }))
                                    dispatch(errorHandlingActions.throwError({
                                        type: "fetchendpoint",
                                        error: e,
                                        level: ErrorBoundaryTypes.log,
                                        props: {
                                            provider: provider,
                                            endpoint: endpoint
                                        }
                                    }))
                                }
                            }
                        })
                    }

                })
            }
        }
    }
}

const endPointWithKey = (endpoint, key) => ({
    ...endpoint,
    endpointKey: key
}
)
const shouldFetchEndpoint = (endpoint, isAuth) => {
    return (endpoint.auth === endpointsAuth.cookie && isAuth) || (endpoint.auth === endpointsAuth.none)
}
const groupCoursesBySystemId = (courses) => {
    const groupedCourses = {};

    courses.forEach(course => {
        const system = course.system; // Assuming there is a systemId field in the course object

        if (!groupedCourses[system]) {
            groupedCourses[system] = [];
        }

        groupedCourses[system].push(course);
    });

    return groupedCourses;
};

// Helper function to find provider by system Id
const findProviderBySystemId = (providers, systemId) => {
    return providers.find(provider => provider.systemId.toLowerCase() === systemId.toLowerCase());
};